var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithoutnot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8125 22.5312V23.8438H0.1875V22.5312L2.8125 19.9062V12.0312C2.8125 7.9625 5.47687 4.37937 9.375 3.22437C9.375 3.09312 9.375 2.975 9.375 2.84375C9.375 2.14756 9.65156 1.47988 10.1438 0.987595C10.6361 0.495312 11.3038 0.21875 12 0.21875C12.6962 0.21875 13.3639 0.495312 13.8562 0.987595C14.3484 1.47988 14.625 2.14756 14.625 2.84375C14.625 2.975 14.625 3.09312 14.625 3.22437C18.5231 4.37937 21.1875 7.9625 21.1875 12.0312V19.9062L23.8125 22.5312ZM14.625 25.1562C14.625 25.8524 14.3484 26.5201 13.8562 27.0124C13.3639 27.5047 12.6962 27.7812 12 27.7812C11.3038 27.7812 10.6361 27.5047 10.1438 27.0124C9.65156 26.5201 9.375 25.8524 9.375 25.1562",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutnot);
export default __webpack_public_path__ + "static/media/without not.244e73a7486db3b30a934085bc85ed1f.svg";
export { ForwardRef as ReactComponent };